<template>
  <v-container>
    <v-dialog v-model="dialog" persistent :retain-focus="false" max-width="800">
      <v-card class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="pb-5">
          <v-row>
            <v-col cols="12" class="justify-start d-flex">
              Application Form
            </v-col>
          </v-row>
          <v-btn icon @click="close" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="custom-divider"></v-divider>

        <v-card-text>
          <v-form ref="form">
            <v-row class="justify-center">
              <v-col cols="12" class="pb-0">
                <label class="font-weight-bold subtitle-2">{{ $t('firstName') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your first name'"
                  outlined
                  required
                  :rules="requiredRule()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('lastName') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your last name'"
                  outlined
                  required
                  :rules="requiredRule()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('email') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your email'"
                  outlined
                  required
                  :rules="emailRules()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('institution') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your institution'"
                  outlined
                  required
                  :rules="requiredRule()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('position') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your position'"
                  outlined
                  required
                  :rules="requiredRule()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('mobilePhone') }}</label>
                <v-text-field
                  class="pt-2"
                  :placeholder="'Fill your phone'"
                  outlined
                  required
                  :rules="requiredRule()"
                  type="number"
                  hide-spin-buttons
                >
                </v-text-field>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('description') }}</label>
                <v-textarea
                  class="pt-2"
                  :placeholder="'Description'"
                  outlined
                  required
                  :rules="requiredRule()"
                ></v-textarea>
              </v-col>
              <v-col cols="12 pt-0">
                <label class="text-bold subtitle-2">{{ $t('Link') }}</label>
                <v-text-field class="pt-2" :placeholder="'Enter link'" outlined> </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-row>
            <v-col>
              <v-btn
                v-if="firstQuestion || secondQuestion"
                large
                class="rounded-lg black--text font-weight-bold"
                outlined
                color="black"
                block
                @click="nextDialog"
                >{{ $t('next') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Question Dialog -->
    <v-dialog
      v-model="questionDialog"
      max-width="800"
      persistent
      :retain-focus="false"
      v-if="firstQuestion || secondQuestion"
    >
      <v-card class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-row justify="end">
          <v-btn icon @click="closeQuestionDialog" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-card-text class="mt-0" v-if="firstQuestion">
          <h2>
            {{ firstQuestion }}
          </h2>
        </v-card-text>
        <v-card-text class="mt-0" v-if="firstQuestion">
          <v-radio-group v-model="selectedAnswer">
            <v-radio
              v-for="(answer, index) in firstAnswer"
              :key="index"
              :label="answer"
              :value="answer"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-text class="mt-0" v-if="secondQuestion">
          <h2>
            {{ secondQuestion }}
          </h2>
        </v-card-text>
        <v-card-text v-if="secondQuestion">
          <v-textarea
            label="Message"
            maxlength="100"
            counter
            outlined
            single-line
            required
            :rules="requiredRule()"
          ></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import util from '@/mixins/util';
import service from '@/services/base-service';

export default {
  name: 'ApplicationFormForPreview',
  mixins: [util, service],
  props: {
    dialog: Boolean,
    firstQuestion: String,
    secondQuestion: String,
    firstAnswer: Array,
  },
  data: () => ({
    questionDialog: false,
    selectedAnswer: null,
  }),

  methods: {
    close() {
      this.$emit('close');
      this.$refs.form.reset();
    },
    closeQuestionDialog() {
      this.questionDialog = false;
    },
    nextDialog() {
      this.questionDialog = true;
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding: 5px 0;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}
</style>
